import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"
import api from "@/services/api"

import basket from "./modules/basket"

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: state => ({ basket: state.basket })
})

export default new Vuex.Store({
  modules: { basket },
  plugins: [vuexLocal.plugin],
  state: {
    page: {},
    site_id: "wortleybros",

    settings: null,
    contact_info: null,
    misc: null,
    pricing: null,
    sizing: null,
    posts: null,
    treatments: null,
    ironmongery: null,
    main_pages: null,
    categories: null,
    testimonials: null,
    gallery: null,
    help_page: null,
    contact_page: null,
    faqs_page: null,

    basket_page: null,
    checkout_page: null,

    IDs: {
      homeID: "NP51WfwAu",
      testimonialsID: "ze1S4Jqps",
      galleryID: "AjXtLod_r",
      helpID: "IENQNbwO5",
      basketID: "Pgv-Y42Qy",
      checkoutID: "robZcXdnR",
      faqsID: "hb_DWudB1",
      contactID: "z8k04iaUS",
      successID: "S12tMwGQV",
      failureID: "jPXPPMC5M",
      postsID: "fcS4LyyIi",
      ironmongeryID: "Fnnq5jSyS",
      treatmentsID: "sjxRSWmuO",
      sidePanelID: "vSoYAhB2b",
      saleGatesID: "6avv1tbEX",
      threeQuarterID: "5egUfru0U",
      singleID: "lqwgc7JfV",
      doubleID: "jLwzx4C6b",
      garageID: "s5QA183o8",
      fiveBarID: "LKCVecml2",
      saleID: "6avv1tbEX"
    }
  },
  getters: {
    main_menu(state) {
      if (state.main_pages) return state.main_pages.slice(0, 6)
      else return []
    },
    isHomePage(state) {
      return state.page.ItemID && state.page.ItemID == state.IDs.homeID
    },
    isFaqsPage(state) {
      return state.page.ItemID && state.page.ItemID == state.IDs.faqsID
    },
    isGalleryPage(state) {
      return state.page.ItemID && state.page.ItemID == state.IDs.galleryID
    },
    isTestimonialsPage(state) {
      return state.page.ItemID && state.page.ItemID == state.IDs.testimonialsID
    },
    isContactPage(state) {
      return state.page.ItemID && state.page.ItemID == state.IDs.contactID
    },
    isGeneric(state, getters) {
      return (
        state.page.ItemID && !getters.isHomePage && !getters.isProduct && !getters.isCategory && !getters.isExtraCat
      )
    },
    isProduct(state) {
      return state.page.ItemType == "page.products"
    },
    isCategory(state) {
      return (
        state.page.ItemType == "page.categories" &&
        state.page.ItemID != state.IDs.postsID &&
        state.page.ItemID != state.IDs.ironmongeryID &&
        state.page.ItemID != state.IDs.treatmentsID
      )
    },
    isExtraCat(state) {
      return (
        state.page.ItemID == state.IDs.postsID ||
        state.page.ItemID == state.IDs.ironmongeryID ||
        state.page.ItemID == state.IDs.treatmentsID
      )
    },
    isBasket(state) {
      return state.page.ItemID && state.page.ItemID == state.IDs.basketID
    },
    isCheckout(state) {
      return state.page.ItemID && state.page.ItemID == state.IDs.checkoutID
    },
    isSuccess(state) {
      return state.page.ItemID && state.page.ItemID == state.IDs.successID
    },
    isFailure(state) {
      return state.page.ItemID && state.page.ItemID == state.IDs.failureID
    }
  },
  mutations: {
    setPage(state, page) {
      state.page = page
    },
    setTestimonials(state, testimonials) {
      state.testimonials = testimonials
    },
    setGallery(state, gallery) {
      state.gallery = gallery
    },
    setContactInfo(state, contact_info) {
      state.contact_info = contact_info
    },
    setMisc(state, misc) {
      state.misc = misc
    },
    setPricing(state, pricing) {
      state.pricing = pricing
    },
    setSizing(state, sizing) {
      state.sizing = sizing
    },
    setMainPages(state, main_pages) {
      state.main_pages = main_pages
      main_pages.forEach(page => {
        if (page.ItemID == state.IDs.contactID) state.contact_page = page
        if (page.ItemID == state.IDs.helpID) state.help_page = page
        if (page.ItemID == state.IDs.faqsID) state.faqs_page = page

        if (page.ItemID == state.IDs.basketID) state.basket_page = page
        if (page.ItemID == state.IDs.checkoutID) state.checkout_page = page
      })
    },
    setPosts(state, posts) {
      state.posts = posts
    },
    setIronmongery(state, ironmongery) {
      state.ironmongery = ironmongery
    },
    setTreatments(state, treatments) {
      state.treatments = treatments
    },
    setCategories(state, categories) {
      state.categories = categories
    }
  },
  actions: {
    getTestimonials({ commit, state }) {
      return new Promise(resolve => {
        if (!state.testimonials)
          api.getPageByItemID(state.IDs.testimonialsID, "testimonials").then(testimonialspage => {
            commit("setTestimonials", testimonialspage.testimonials)
            resolve()
          })
        else resolve()
      })
    },
    getContactInfo({ commit, state }) {
      return new Promise(resolve => {
        if (!state.contact_info)
          api.getPageByItemID("CONTACTINFO").then(contact_info => {
            commit("setContactInfo", contact_info)
            resolve()
          })
        else resolve()
      })
    },
    getMisc({ commit, state }) {
      return new Promise(resolve => {
        if (!state.misc)
          api.getPageByItemID("MISC").then(misc => {
            commit("setMisc", misc)
            resolve()
          })
        else resolve()
      })
    },
    getPricing({ commit, state }) {
      return new Promise(resolve => {
        if (!state.pricing)
          api.getPageByItemID("PRICING").then(pricing => {
            commit("setPricing", pricing)
            resolve()
          })
        else resolve()
      })
    },
    getSizing({ commit, state }) {
      return new Promise(resolve => {
        if (!state.sizing)
          api.getPageByItemID("SIZING").then(sizing => {
            commit("setSizing", sizing)
            resolve()
          })
        else resolve()
      })
    },
    getMainPages({ commit, state }) {
      return new Promise(resolve => {
        if (!state.main_pages)
          api.getPages("page.main").then(main_pages => {
            commit("setMainPages", main_pages)
            resolve()
          })
        else resolve()
      })
    },
    getPosts({ commit, state }) {
      return new Promise(resolve => {
        if (!state.posts)
          api.getPages("page.posts", "image,available_on,options,description,promo,delivery").then(posts => {
            commit("setPosts", posts)
            resolve()
          })
        else resolve()
      })
    },
    getIronmongery({ commit, state }) {
      return new Promise(resolve => {
        if (!state.ironmongery)
          api
            .getPages("page.ironmongery", "image,available_on,options,description,promo,delivery")
            .then(ironmongery => {
              commit("setIronmongery", ironmongery)
              resolve()
            })
        else resolve()
      })
    },
    getTreatments({ commit, state }) {
      return new Promise(resolve => {
        if (!state.treatments)
          api.getPages("page.treatmentsnew", "image,available_on,options,description,promo").then(treatments => {
            commit("setTreatments", treatments)
            resolve()
          })
        else resolve()
      })
    },
    getCategories({ commit, state }) {
      return new Promise(resolve => {
        if (!state.categories)
          api.getPages("page.categories").then(categories => {
            commit("setCategories", categories)
            resolve()

            var promises = []

            categories.forEach(page => {
              promises.push(
                api.getSubPages("page.products", page.ItemID).then(products => Vue.set(page, "products", products))
              )

              // promises.push(
              //   api
              //     .getPagesPOST(
              //       "#images, #baseprice",
              //       "page.products",
              //       "#category = :catid",
              //       {
              //         ":catid": dynamodb.Converter.input(page.ItemID)
              //       },
              //       {
              //         "#images": "images",
              //         "#baseprice": "base_price",
              //         "#category": "category"
              //       }
              //     )
              //     .then(products => {
              //       products.sort((a, b) => a.sequence - b.sequence || a.price - b.price)
              //       Vue.set(page, "products", products)
              //     })
              // )
            })

            Promise.all(promises).then(() => {
              commit("setCategories", categories)

              // this.$nextTick().then(() => {
              //   window.$(document).ready(function() {
              //       // Put jQuery for category component here
              //   })
              // })
            })
          })
        else resolve()
      })
    },
    getGallery({ commit, state }) {
      return new Promise(resolve => {
        if (!state.gallery)
          api.getPageByItemID(state.IDs.galleryID, "images").then(gallerypage => {
            commit("setGallery", gallerypage.images)
            resolve()
          })
        else resolve()
      })
    }
  }
})
